import { Link } from 'react-router-dom';

export function TermsOfServicePage() {
  return (
    <div className="min-h-screen bg-[#0B0F10] text-white">
      <header className="border-b border-white/10">
        <div className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 text-[#A9B4B8] hover:text-[#2EC4B6] transition-colors">
            <img src="/eventtools-logo.svg" alt="Event.Tools" className="w-10 h-10 object-contain" />
            <span className="font-display font-bold text-lg text-white">Event.Tools</span>
          </Link>
          <Link to="/" className="text-sm text-[#A9B4B8] hover:text-white transition-colors">Back to home</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <h1 className="font-display font-bold text-3xl md:text-4xl text-white mb-2">Terms of Service</h1>
        <p className="text-[#A9B4B8] text-sm mb-10">Last updated: February 2025</p>

        <div className="prose prose-invert prose-sm max-w-none space-y-8 text-[#A9B4B8] leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-white mb-3">1. Acceptance</h2>
            <p>By accessing or using Event.Tools (“Service”), including the website at event.tools and the Event.Tools Flyer Builder desktop application, you agree to be bound by these Terms of Service. If you do not agree, do not use the Service.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">2. Description of Service</h2>
            <p>Event.Tools provides tools for creating event marketing materials (e.g. flyers) using AI-assisted design and your own assets. The Service may include a web application, desktop application, and related features such as calendar integration and asset management.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">3. Your Responsibilities</h2>
            <p>You are responsible for (a) the accuracy of content you upload or generate, (b) obtaining any rights needed for assets you use (logos, photos, etc.), and (c) complying with applicable laws. You may not use the Service for illegal purposes, to infringe others’ rights, or to generate harmful or misleading content.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">4. Account and Data</h2>
            <p>Where account registration is offered, you must provide accurate information. You are responsible for safeguarding your credentials. We process data as described in our <Link to="/privacy" className="text-[#2EC4B6] hover:underline">Privacy Policy</Link>.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">5. Intellectual Property</h2>
            <p>Event.Tools and its branding are owned by us. You retain ownership of your content and assets. By using the Service you grant us a limited license to process and store your content as needed to operate the Service.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">6. Disclaimers</h2>
            <p>The Service is provided “as is.” We do not guarantee uninterrupted or error-free operation. AI-generated output may be imperfect; you are responsible for reviewing and approving any content before use.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">7. Limitation of Liability</h2>
            <p>To the maximum extent permitted by law, Event.Tools and its providers shall not be liable for any indirect, incidental, special, or consequential damages arising from your use of the Service.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">8. Changes</h2>
            <p>We may update these Terms from time to time. Continued use of the Service after changes constitutes acceptance. We will post the updated Terms on the site and update the “Last updated” date.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-3">9. Contact</h2>
            <p>Questions about these Terms can be sent to <a href="mailto:hello@event.tools" className="text-[#2EC4B6] hover:underline">hello@event.tools</a>.</p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10">
          <Link to="/" className="text-[#2EC4B6] hover:underline text-sm">← Back to Event.Tools</Link>
        </div>
      </main>
    </div>
  );
}
